<template>
	<div class="data5">
		<div class="data5Til">{{list.data.menuTitle}}</div>
		<div class="data5Box">
			<div class="data5For" v-for="(item,index) in list.data.content" :key="index">
				<div class="data5ForImg">
					<img :src="item.cover" />
				</div>
				<div class="data5ForImgTwo">
					<img :src="item.icon" />
				</div>
				<div class="data5ForName">
					{{item.title}}
				</div>
				<div class="data5ForCen">
					<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		components: {

		},
		props:{
			list:{
				typeof:Object,
				default:{}
			}
		},
		data() {
			return {
				njgfList: [{
						img: require('@/assets/product/page2/zlys.png'),
						imgDt: require('@/assets/product/page2/czjyZlys.png'),
						name: '直连盐水',
						cen: '评分可视化呈现，帮助科室管理及评估- 为团队提高诊疗水平提供辅助平台'
					},
					{
						imgDt: require('@/assets/product/page2/czjyJtcs.png'),
						img: require('@/assets/product/page2/jtcs.png'),
						name: '脚踏冲水',
						cen: '- 支持各部位临床图参考- 进一步提升医者的诊疗素养'
					},
				]
			}
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
.data5{
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 150px;
	.data5Til{
		font-size: 45px;
		
		font-weight: bold;
		color: #000000;
		margin-bottom: 66px;
	}
	.data5Box{
		display: flex;
		justify-content: space-between;
		.data5For{
			width: 580px;
			.data5ForImg{
				margin-bottom:  35px;
				img{
					width: 580px;
					height: 440px;
					object-fit: cover;
				}
			}
			.data5ForImgTwo{
				margin-bottom:  35px;
				img{
					width: 70px;
					height: 70px;
					object-fit: contain;
				}
			}
			.data5ForName{
				font-size: 26px;
				
				font-weight: 400;
				color: #000000;
				margin-bottom:  35px;
			}
			.data5ForCen{
				font-size: 18px;
				
				font-weight: 300;
				color: #000000;
				>div{
					white-space: pre-line;
				}
			}
		}
		
	}
	
}
@media screen and (max-width:1200px) {
		.data5{
			width: 100% !important;
			padding:0 30px 30px !important;
			box-sizing: border-box;
			.data5Til{
				font-size: 24px !important;
				margin-bottom: 20px !important;
			}
			.data5Box{
				.data5For{
					width: calc(50% - 20px) !important;
					.data5ForImg{
						margin-bottom:  20px !important;
						img{
							width: 100% !important;
							height: auto !important;
							object-fit: contain !important;
						}
					}
					.data5ForImgTwo{
						margin-bottom:  20px !important;
						img{
							width: 35px !important;
							height: 35px !important;
							object-fit: contain;
						}
					}
					.data5ForName{
						font-size: 18px !important;
						margin-bottom:  20px !important;
					}
					.data5ForCen{
						font-size: 14px !important;
					}
				}
				
			}
			
		}
	}
</style>